import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import HImage from "@cloudpivot/form/src/common/components/image.vue";
let Attachment = class Attachment extends Vue {
    render(h) {
        return h('h-image', { props: {
                disabled: true,
                text: "点击或拖拽上传"
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Attachment.prototype, "control", void 0);
Attachment = tslib_1.__decorate([
    Component({ name: 'Attachment', components: { HImage } })
], Attachment);
export default Attachment;
